<template>
  <div :class="`${clase} primary`" v-if="!quotation" :style="{top: top + 'px', right: right + 'px'}">
    <v-icon small class="pt-1" color="white">far fa-hourglass</v-icon>
  </div>
  <div :class="`${clase} green`" v-else :style="{top: top + 'px', right: right + 'px'}">
    <v-icon small class="pt-1" color="white">fas fa-check</v-icon>
  </div>
</template>
<script>
export default {
  props: {
    quotation: {
      type: Boolean,
      required: true
    },
    top: {
      type: Number,
      default: 7
    },
    right: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      clase: 'status pa-1 text-center elevation-3'
    }
  },
}
</script>
<style scoped>
.status {
  width: 34px;
  height: 34px;
  position: absolute;
  border-radius: 100% !important;
}
</style>


